type MetaDataParams = { [key: string]: any };

const metaPropName = "apiMetaData";

// make metadata usage access more predictable and safe

export function apiMetaData(data: MetaDataParams) {
  return { [metaPropName]: data };
}

export function isApiMetaData(data: any) {
  return data ? data.hasOwnProperty(metaPropName) : false;
}

export function getApiMetaData(data: any): MetaDataParams | undefined {
  return data ? data[metaPropName] : undefined;
}
